import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/meeting_attendance_session/meeting_schedule`;

export const ACTION_TYPES = {
    FETCH_MEETINGSESSION_LIST: 'meetingsession/FETCH_MEETINGSESSION_LIST',
    CREATE_MEETINGSESSION: 'meetingsession/CREATE_MEETINGSESSION',
    RESET: 'meetingsession/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
};

// REDUCER
const meetingattendancesessionReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MEETINGSESSION_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_MEETINGSESSION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_MEETINGSESSION_LIST):
    case FAILURE(ACTION_TYPES.CREATE_MEETINGSESSION):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
        entities: []
      };
    case SUCCESS(ACTION_TYPES.FETCH_MEETINGSESSION_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: [res],
      };
    case SUCCESS(ACTION_TYPES.CREATE_MEETINGSESSION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default meetingattendancesessionReducer;

// ACTIONS
export const getEntities = (id) => ({
  type: ACTION_TYPES.FETCH_MEETINGSESSION_LIST,
  payload: axios.get(`${apiUrl}/${id}`)
});

export const createEntity = (id, entity) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MEETINGSESSION,
    payload: axios.post(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
